module.exports = __webpack_public_path__ + "img/img-tag-new.svg";